/**
 * @generated SignedSource<<82a1df34aa63d7968e489d43648de5d0>>
 * @relayHash 84e141f4639993fa671b560586b064ac
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 8efac480ec4a436c1a451826fa401d62a5e1cb57c29989be5ed579813655fbf2

import type { ConcreteRequest } from 'relay-runtime';
export type ContentPrerequisitesQuery$variables = {
  contentId: string;
  missingSpaceKey?: boolean | null;
  spaceKey?: string | null;
};
export type ContentPrerequisitesQuery$data = {
  readonly content: {
    readonly nodes: ReadonlyArray<{
      readonly id: string | null;
      readonly space: {
        readonly alias: string | null;
        readonly id: string | null;
        readonly key: string | null;
      } | null;
      readonly type: string | null;
    } | null> | null;
  } | null;
  readonly space?: {
    readonly id: string | null;
    readonly name: string | null;
  } | null;
};
export type ContentPrerequisitesQuery = {
  response: ContentPrerequisitesQuery$data;
  variables: ContentPrerequisitesQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "contentId"
  },
  {
    "defaultValue": false,
    "kind": "LocalArgument",
    "name": "missingSpaceKey"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "spaceKey"
  }
],
v1 = {
  "kind": "ScalarField",
  "name": "id"
},
v2 = [
  {
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "contentId"
      }
    ],
    "concreteType": "PaginatedContentListWithChild",
    "kind": "LinkedField",
    "name": "content",
    "plural": false,
    "selections": [
      {
        "concreteType": "Content",
        "kind": "LinkedField",
        "name": "nodes",
        "plural": true,
        "selections": [
          (v1/*: any*/),
          {
            "kind": "ScalarField",
            "name": "type"
          },
          {
            "concreteType": "Space",
            "kind": "LinkedField",
            "name": "space",
            "plural": false,
            "selections": [
              (v1/*: any*/),
              {
                "kind": "ScalarField",
                "name": "key"
              },
              {
                "kind": "ScalarField",
                "name": "alias"
              }
            ]
          }
        ]
      }
    ]
  },
  {
    "condition": "missingSpaceKey",
    "kind": "Condition",
    "passingValue": false,
    "selections": [
      {
        "args": [
          {
            "kind": "Variable",
            "name": "key",
            "variableName": "spaceKey"
          }
        ],
        "concreteType": "Space",
        "kind": "LinkedField",
        "name": "space",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          {
            "kind": "ScalarField",
            "name": "name"
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "ContentPrerequisitesQuery",
    "selections": (v2/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ContentPrerequisitesQuery",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "84e141f4639993fa671b560586b064ac",
    "id": "8efac480ec4a436c1a451826fa401d62a5e1cb57c29989be5ed579813655fbf2",
    "metadata": {},
    "name": "ContentPrerequisitesQuery",
    "operationKind": "query",
    "text": "query ContentPrerequisitesQuery($contentId:ID!,$missingSpaceKey:Boolean=false,$spaceKey:String){content(id:$contentId){nodes{id,type,space{id,key,alias}}},space(key:$spaceKey)@skip(if:$missingSpaceKey){id,name}}"
  }
};
})();

(node as any).hash = "0027e387b6111f3e5ddcfb9450c87857";

export default node;
